<template>
  <div class="p-anken-detail__detail" v-bind:class="{ 'is-contact': job.is_contact }">
      <div class="p-anken-detail__detail__top">
        <p><span class="number">No.{{ formartNo(job.id.toString()) }}</span>更新日<span class="day">{{ formatDate(job.created_at) }}</span></p>
        <p v-if="user" class="star_logo" @click="bookmark(job.id)">
          <img v-if="is_bookmark == false"src="/images/pc/anken_detail_star1.png" alt="star">
          <img v-if="is_bookmark == true" src="/images/pc/anken_detail_star2.png" alt="star">
        </p>
      </div>
      <h1 class="p-anken-detail__detail__title bold">{{job.name}}</h1>
      <div class="p-anken-detail__detail__list">
        <p><img :src="'/images/' + imageType + '/anken_detail_yen.png'" alt=""></p>
        <p><span class="bold mr25">{{formatPrice(job.price_from)}} 〜{{formatPrice(job.price_to)}}</span><span class="mr25">／月</span>{{job.deal_type}}</p>
      </div>
      <div class="p-anken-detail__detail__list">
        <p><img :src="'/images/' + imageType + '/anken_detail_spot.png'" alt=""></p>
        <p><span class="bold">{{job.place}}</span></p>
      </div>
      <div class="p-anken-detail__detail__list">
        <p><img :src="'/images/' + imageType + '/anken_detail_schedule.png'" alt=""></p>
        <p><span class="bold mr25">{{job.join}}</span></p>
      </div>
      <div class="p-anken-detail__detail__list">
        <p><img :src="'/images/' + imageType + '/anken_detail_skill.png'" alt=""></p>
        <p>
          <a class="skill skill--link" v-for="(tag, index) in job.tags_link" v-bind:key="`tag-link-${index}`" v-bind:href="`/job/${tag.canonical_name}`">{{tag.name}}</a>
          <span class="skill" v-for="(tag, index) in job.tags_no_link" v-bind:key="`tag-no-link-${index}`">{{tag.name}}</span>
        </p>
      </div>
      <div class="p-anken-detail__detail__content open">
        <div class="p-anken-detail__detail__content-top">
          <p class="title bold">内容</p>
          <p class="text pre-formatted" v-html="job.description">
          </p>
          <p class="bold title">必須スキル</p>
          <p class="text pre-formatted" v-html="job.skill_required">
          </p>
          <p class="bold title">尚可スキル</p>
          <p class="text pre-formatted" v-html="job.skill_extra">
          </p>
          <p class="bold title">面談</p>
          <p class="text pre-formatted" v-html="job.interview">
          </p>
          <p class="bold title">備考</p>
          <p class="text pre-formatted" v-html="job.note">
          </p>
        </div>
        <div v-if="job.admin_comment" class="p-anken-detail__detail__content-bottom avatar">
          <p>
            <img :src="job.admin.avatar_image_path" alt="">
          </p>
          <p class="pre-formatted" v-html="job.admin_comment"></p>
        </div>

        <a v-if="job.is_contact" class="p-anken-detail__detail__content-submit" :data-target="'modal-contact-' + this.job.id">
          エントリー中
        </a>

        <a v-if="user && !job.is_contact" href="javascript:void(0);" @click="contact(job.id)" class="p-anken-detail__detail__content-submit">
          案件エントリー
        </a>

        <a v-if="!user && !job.is_contact" href="javascript:void(0);" :data-target="'modal-' + this.job.id" class="js-modal-open p-anken-detail__detail__content-submit">
          案件エントリー
        </a>

      </div>

      <div class="modal js-modal" :id="'modal-' + this.job.id">
          <div class="modal__bg">
            <article v-bind:class="formClass" class="is-modal">
              <div v-if="isMobile" class="js-modal-close"></div>
              <div v-if="isMobile" class="o-form__sp__description">
                <p class="left">
                  会員登録をすると、あなたのスキルやご希望条件にマッチした案件をご案内することができます。<br>
                  当サイトに掲載されていない案件もございます。<br>
                  案件やお仕事お探しに関してのご相談やご質問もお気軽にお問合せくださいませ！<br>
                  ※会員登録済みの方は<a href="/login">こちら</a>からログインいただき案件エントリーお願いします。
                </p>
              </div>
              <div class="innerBox">
                <div v-if="!isMobile" class="js-modal-close"></div>
                <form-user-register
                    :errors="[]"
                    :data="[]"
                    :job-id="job.id"
                    :is-mobile="isMobile"
                    :is-modal="true"
                    :is-ajax="true">
                    <input type="hidden" name="modal-contact" value="1">
                </form-user-register>
              </div>
            </article>
          </div>
      </div>

      <div class="modal" :id="'modal-contact-' + this.job.id">
        <div class="modal__bg modal__band">
          <article class="is-modal o-modal__band__wrap">
            <div class="o-modal__band__contents">
              <div class="modal-close-button js-modalModule-is-close"></div>
              <img src="/images/logo.svg" class="o-modal__band__contents__icon" alt="">
              <div class="o-modal__band__contents__text">
                <p>案件エントリーいただきありがとうございます。</p>
                <p>ご登録のメールアドレスに自動返信メールが送信されました。</p>
                <p>担当よりご連絡いたしますので、今しばらくお待ち下さい。</p>
              </div>
            </div>
          </article>
        </div>
      </div>
      <slot></slot>

  </div>
</template>

<script>
import Form from "@/utils/Form";
import { formatPrice, formatDate } from '@/utils/Helper'
import { modalOpen } from '@/utils/Modal'

export default {
  props: {
    data: {
      type: Array | Object | null,
      default: null,
      required: false,
    },
    isMobile : {
      type: Boolean,
      default: false,
      required: false,
    },
    user: {
      type: Array | Object | null,
      default: false,
      required: false,
    }
  },
  components: {
  },
  data() {
    return {
      job: this.data,
      form: new Form({
      }),
      is_bookmark: this.data.is_bookmark,
      imageType: this.isMobile ? 'sp' : 'pc',
      formClass: this.isMobile ? 'o-form__sp' : 'o-form__pc',
      sending: false
    }
  },
  methods: {
    formatPrice(price) {
      return formatPrice(price / 10000) + '万'
    },

    formatDate(date) {
      return formatDate(date, 'YYYY.MM.DD')
    },

    formartNo(str) {
      return str.padStart(7, '0');
    },

    bookmark(jobId) {
      this.form
          .post({
            url: "/job/bookmark/" + jobId,
          })
          .then(({}) => {
            this.is_bookmark = !this.is_bookmark
          })
          .catch((error) => {
          });
    },

    contact(jobId) {
      if (this.sending) {
        return;
      }
      var modalId = "modal-contact-" + jobId
      this.sending = true;
      this.form
          .post({
            url: "/job/contact/" + jobId,
          })
          .then(({data: {data}}) => {
            this.job = data
            this.sending = false
            modalOpen(modalId)
          })
          .catch((error) => {
            this.sending = false
          });
    },
  },
  mounted() {
  },
  computed: {

  }
}
</script>
